import ahoy from "ahoy_setup";

function trackLiteratureDownload(link) {
  const container = $(link).closest(".download");
  const payload = {
    item_id: container.data("item-id") || "",
    item_name: container.data("item-name") || "",
    file_type: container.data("file-type") || "file",
    link_url: link.href
  };

  // Basic Consent Mode leaves GTM unloaded until a valid choice exists. Send
  // the GA4 event only after that loader has run, so pre-consent clicks are not
  // retained for later delivery.
  if (window.googleTagManagerLoaded && typeof window.gtag === "function") {
    window.gtag("event", "literature_download_click", payload);
  }

  if (window.performanceConsentGranted) {
    ahoy.track("Download", {
      slug: container.data("slug"),
      item: "Product",
      file_type: payload.file_type
    });
  }
}

$(document)
  .off("click.literatureDownload", ".download a")
  .on("click.literatureDownload", ".download a", function() {
    trackLiteratureDownload(this);
  });
